import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { PrManagersPersonaPage } from "@/components/site/PrManagersPersonaPage";
import { PR_MANAGERS_META_DESCRIPTION } from "@/content/meta/PrManagersPersonaPage";

import { pageSchemas } from "@/lib/seo/page-schema";
export const Route = createFileRoute("/who-we-help/pr-managers")({
  head: () => ({
    meta: [
      { title: "Media Intelligence for PR Managers | Perceptica" },
      { name: "description", content: PR_MANAGERS_META_DESCRIPTION },
      { property: "og:title", content: "Media Intelligence for PR Managers | Perceptica" },
      { property: "og:description", content: PR_MANAGERS_META_DESCRIPTION },
      { name: "twitter:title", content: "Media Intelligence for PR Managers | Perceptica" },
      { name: "twitter:description", content: PR_MANAGERS_META_DESCRIPTION },

      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:url", content: "https://perceptica.com/who-we-help/pr-managers" },
      ...ogImageMeta("en", "/who-we-help/pr-managers"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "en", path: "/who-we-help/pr-managers" }),
  }),
  component: PrManagersPersonaPage,
});
